export const loadFile = (filename) => {
    if (filename) {
        return `${process.env.REACT_APP_BACKEND_URL}/download-producto/${filename.split('/')[1]}`;
    }
    return null;
}
